/* unplugin-vue-components disabled */import { render } from "./CoveoAILoggedIn.vue?vue&type=template&id=2a4660d3"
import script from "./CoveoAILoggedIn.vue?vue&type=script&lang=js"
export * from "./CoveoAILoggedIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__